import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import _isNumber from "lodash/isNumber";
import _capitalize from "lodash/capitalize";
import _isEmpty from "lodash/isEmpty";
import _get from "lodash/get";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import classNames from 'classnames';
import { Type } from '@nerdwallet/currency';
import React, { Fragment } from 'react';
import LikelihoodOfApproval, { approvalOddsPopoverContent, getColorAndLabel, getCreditScoreComparisonContent, Heading, CREDIT_DASHBOARD_PATH_WITH_TRK } from '@nerdwallet/likelihood-of-approval';
import { getApprovalOdds, getLegacyId, getMaximumFICO, getMinimumFICO, getOngoingAPR, getSlug, getStarRating, getTermsAndFeesLink } from '@nerdwallet/marketplace/selectors/credit-cards';
import { getRecommendedCreditScoreFormattedDetails, getMaxCreditScoreBucket, getMinCreditScoreBucket } from '@nerdwallet/marketplace/utils/credit-cards';
import MarketplaceApplyNow, { APPLY_NOW_LINK_TYPES, APPLY_NOW_FINISH_TYPES, LINK_TYPES } from '@nerdwallet/react-marketplace-apply-now';
import classes from '@nerdwallet/base-styles/dist/classes';
import MarketplaceStarRating, { LAYOUTS, TOOLTIP_TEXT } from '@nerdwallet/react-marketplace-star-rating';
import { getMonetizable } from './utils';
import { FORMATS, VALUE_SIZES } from '../constants';
import styles from '../quick-facts.module.less';
/**
 * Preserve exports for backwards compatibility.
 * @deprecated - Leverage exports from `@nerdwallet/marketplace/drivers/credit-cards` directly.
 */

export { getDriverAnnualFee as getQuickFactAnnualFee, getDriverBalanceTransferFeeDescription as getQuickFactBalanceTransferFeeDescription, getDriverBonus as getQuickFactEstBonusValue, getDriverIntroApr as getQuickFactIntroApr, getDriverIntroOffer as getQuickFactIntroOffer, getDriverRecommendedCreditScoreRange as getQuickFactRecommendedCreditScoreRange, getDriverRewardRate as getQuickFactRewardRate, getDriverMinimumDepositDescription as getQuickFactMinimumDepositDescription } from '@nerdwallet/marketplace/drivers/credit-cards';
/**
 * Preserve exports for backwards compatibility.
 * @deprecated - Leverage export from `@nerdwallet/marketplace/utils/credit-cards` directly.
 */

export { getRecommendedCreditScoreFormattedDetails };
export var WAIVED_FIRST_YEAR_STRING = 'Waived first year';
export var DISCLAIMER_TEXT = 'But, heads up, being within the recommended range doesn’t guarantee approval. Credit score is only one factor lenders consider and they may not use the TransUnion Vantage Score like we do.';
export var TRANSUNION_LOGO_CTA = /*#__PURE__*/React.createElement("a", {
  href: CREDIT_DASHBOARD_PATH_WITH_TRK,
  target: "_",
  className: classes('display-block')
}, /*#__PURE__*/React.createElement("div", {
  className: classNames('tu-logo', styles.tuLogo)
}));
/**
 * A getter for credit score given identity object.
 *
 * @param {object} options
 * @param {object} options.identity
 */

export var getCreditScore = function getCreditScore(options) {
  return _get(options, 'identity.profiles.tu_credit_report_profile.vantage_score_3');
};
/**
 * Get the Likelihood of Approval quick fact
 *
 * @param   {Object}  offer                                   The CC offer.
 * @param   {Object}  options
 * @param   {Object}  options.identity                        The identity object typically found in state
 *                                                            This is used to determine if the user is logged in
 *                                                            as well as the user's credit score
 * @param   {node}    options.ctaComponent                    A custom CTA Component
 * @param   {Object}  options.trackingProps
 * @param   {string}  options.trackingProps.impressionKey     The product impression key
 * @param   {string}  options.trackingProps.sectionCategory   The section category
 * @param   {number}  options.trackingProps.sectionPosition   The section position
 *
 * @return  {Object}  The likelihood of approval quick fact
 */

export var getQuickFactLikelihoodOfApproval = function getQuickFactLikelihoodOfApproval(offer) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var creditScore = getCreditScore(options); // Generate props to pass to both the LOA and the LOA heading.

  var commonProps = _objectSpread({
    approvalOdds: getApprovalOdds(offer),
    creditScore: creditScore,
    id: getSlug(offer),
    maxCreditScoreRange: getMaxCreditScoreBucket(offer),
    minCreditScoreRange: getMinCreditScoreBucket(offer)
  }, options);

  return {
    label: /*#__PURE__*/React.createElement(Heading, _extends({}, commonProps, {
      unstyled: true
    })),
    id: 'likelihoodOfApproval',
    value: !_isEmpty(offer) ? /*#__PURE__*/React.createElement(LikelihoodOfApproval, _extends({
      backgroundColor: "transparent",
      cardId: getLegacyId(offer),
      fullWidth: true,
      omitHeading: true,
      redirect_uri: "#",
      useTracking: _get(options.identity, 'isSignedIn', false)
    }, commonProps, options.trackingProps)) : null,
    valueFormat: FORMATS.UNFORMATTED,
    wide: true
  };
};
/**
 * @todo - Create Structured Content compatible value, tooltip and backport into `@nerdwallet/marketplace/drivers/credit-cards`.
 * @see {@link https://nerdwallet.atlassian.net/browse/RUR-171}
 *
 * Get the likelihood of approval text quick fact
 * This is for the Keto Card AB test to replace the `getQuickFactLikelihoodOfApproval`
 *
 * |-------------------------------------------------------------------------------------------|
 * |                  |  TU-activated          | Not TU-activated                              |
 * |-------------------------------------------------------------------------------------------|
 * |Approval odds     |  approval odds text    | Show text-based rec score & approval odds cta |
 * |-------------------------------------------------------------------------------------------|
 * |No approval odds  |  Show user's score     | Show text-based rec score & approval odds cta |
 * |-------------------------------------------------------------------------------------------|
 * @param   {Object}  offer                   The CC offer.
 * @param   {Object}  options
 * @param   {Object}  options.identity        The identity object typically found in state
 *                                            This is used to determine if the user is logged in
 *                                            as well as the user's credit score
 * @param   {node}    options.ctaComponent    A custom CTA Component. MPC currently passes one
 *                                            in for getQuickFactLikelihoodOfApproval()
 * @return  {Object}                          The likelihood of approval text quick fact
 */

export var getQuickFactLikelihoodOfApprovalText = function getQuickFactLikelihoodOfApprovalText(offer) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var minCreditScoreIndex = getMinimumFICO(offer);
  var maxCreditScoreIndex = getMaximumFICO(offer);

  if (!(minCreditScoreIndex && maxCreditScoreIndex)) {
    return null;
  }

  var recommendedCreditScoreText = getRecommendedCreditScoreFormattedDetails(offer, maxCreditScoreIndex, minCreditScoreIndex);
  var approvalOdds = getApprovalOdds(offer);
  var creditScore = getCreditScore(options);
  var loaLabel = 'Recommended Credit Score';
  var loaLabelTooltip;
  var loaValue;
  var loaValueTooltip;

  if (approvalOdds && creditScore) {
    loaValue = _capitalize(getColorAndLabel({
      approvalOdds: approvalOdds
    }).label);
    loaLabel = 'Your approval odds';
    loaValueTooltip = approvalOddsPopoverContent(approvalOdds);
  } else if (!approvalOdds && creditScore) {
    // note that @quick-fact-max-width is limiting the full extension of the loavalue for desktop in the current grid layout
    loaValue = /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: classes('display-flex')
    }, /*#__PURE__*/React.createElement("div", null, creditScore), /*#__PURE__*/React.createElement("div", null, TRANSUNION_LOGO_CTA)), /*#__PURE__*/React.createElement("div", null, "(".concat(recommendedCreditScoreText.creditScoreRange, ")")));
    var creditScoreComparisonContent = getCreditScoreComparisonContent(creditScore, maxCreditScoreIndex, minCreditScoreIndex);
    loaLabelTooltip = /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Type, {
      className: classes(['color-neutral-darkest', 'margin-bottom-2'])
    }, "You're", /*#__PURE__*/React.createElement("strong", null, " ".concat(creditScoreComparisonContent.pointDifference)), " ".concat(creditScoreComparisonContent.relativeScoreLabel, " suggested score of "), /*#__PURE__*/React.createElement("strong", null, creditScoreComparisonContent.scoreToCompare), "."), /*#__PURE__*/React.createElement(Type, {
      className: classes(['color-neutral-darkest'])
    }, DISCLAIMER_TEXT));
  } else {
    loaValue = /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: classes('display-flex--wide')
    }, /*#__PURE__*/React.createElement("div", {
      className: classes('margin-right-1')
    }, recommendedCreditScoreText.creditScoreRange), /*#__PURE__*/React.createElement("div", null, "(".concat(recommendedCreditScoreText.creditScoreRangeDescription, ")"))), /*#__PURE__*/React.createElement("div", null, options.ctaComponent));
  }

  return {
    id: 'likelihoodOfApproval',
    label: loaLabel,
    labelTooltip: loaLabelTooltip,
    value: !_isEmpty(offer) ? loaValue : null,
    valueSize: VALUE_SIZES.MEDIUM,
    valueTooltip: loaValueTooltip
  };
};
/**
 * @todo - Create Structured Content compatible description and backport into `@nerdwallet/marketplace/drivers/credit-cards`.
 * @see {@link https://nerdwallet.atlassian.net/browse/RUR-171}
 */

export var getQuickFactRegularApr = function getQuickFactRegularApr(offer) {
  var _productImpressionPro;

  var includeRatesAndFeesLink = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var shouldLogImpression = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var productImpressionProps = arguments.length > 3 ? arguments[3] : undefined;
  var termsAndFeesLink = getTermsAndFeesLink(offer);
  return {
    id: 'regularApr',
    label: 'Regular APR',
    value: getOngoingAPR(offer),
    valueSize: VALUE_SIZES.MEDIUM,
    description: includeRatesAndFeesLink && termsAndFeesLink ? /*#__PURE__*/React.createElement(MarketplaceApplyNow, {
      className: styles.secondaryCta,
      finishType: APPLY_NOW_FINISH_TYPES.EXTERNAL_CONTENT,
      impressionId: productImpressionProps === null || productImpressionProps === void 0 ? void 0 : productImpressionProps.productImpressionId,
      id: APPLY_NOW_LINK_TYPES.ratesAndFeesText,
      link: termsAndFeesLink,
      linkType: APPLY_NOW_LINK_TYPES.ratesAndFeesText,
      marketplaceEntity: offer,
      monetizable: getMonetizable(offer),
      sectionName: productImpressionProps === null || productImpressionProps === void 0 ? void 0 : (_productImpressionPro = productImpressionProps.payload) === null || _productImpressionPro === void 0 ? void 0 : _productImpressionPro.section_name,
      type: LINK_TYPES.LINK,
      shouldLogImpression: shouldLogImpression
    }, "Rates & Fees") : null
  };
};
/**
 * @todo - Create Structured Content compatible value and backport into `@nerdwallet/marketplace/drivers/credit-cards`.
 * @see {@link https://nerdwallet.atlassian.net/browse/RUR-171}
 *
 * Get the star rating.
 * @param   {Object}  offer  The CC offer.
 * @return  {Object}  The star rating.
 */

export var getQuickFactStarRating = function getQuickFactStarRating(offer, starRatingProps) {
  if (!(starRatingProps === null || starRatingProps === void 0 ? void 0 : starRatingProps.showNotYetRated) && !(_isNumber(starRatingProps === null || starRatingProps === void 0 ? void 0 : starRatingProps.starRating) || _isNumber(getStarRating(offer)))) {
    return null;
  }

  var starRating = /*#__PURE__*/React.createElement(MarketplaceStarRating, _extends({
    marketplaceEntity: offer,
    layout: LAYOUTS.SMALL_NUMERIC,
    omitRatingNumberHref: false,
    hideRatingText: true,
    className: classNames(classes('display-inline-flex'), styles.starRatingValue)
  }, starRatingProps));
  return {
    id: 'starRating',
    label: 'NerdWallet rating',
    value: starRating,
    valueSize: VALUE_SIZES.MEDIUM,
    valueTooltip: TOOLTIP_TEXT.credit_cards
  };
};